import { Component, computed, inject, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { AssistantType, FunctionInterface } from '@vendasta/ai-assistants';
import { GalaxyColumnDef, GalaxyDataSource, GalaxyTableModule, Row } from '@vendasta/galaxy/table';
import { AiAssistantService } from '../../../core/services/ai-assistant.service';
import { ACCOUNT_GROUP_ID_TOKEN, PARTNER_ID_TOKEN } from '../../../core/tokens';
import { AiToolsTableDataSource } from './ai-tools-table.data-source';

@Component({
  selector: 'ai-tools-table',
  imports: [GalaxyTableModule, MatTableModule, MatIconModule],
  templateUrl: './ai-tools-table.component.html',
  styleUrl: './ai-tools-table.component.scss',
})
export class AiToolsTableComponent {
  accountGroupId$ = inject(ACCOUNT_GROUP_ID_TOKEN);
  partnerId$ = inject(PARTNER_ID_TOKEN);
  aiAssistantService = inject(AiAssistantService);

  assistantType = input.required<AssistantType>();
  excludedFunctionIds = input<string[]>([]);
  selectedFunctions = output<FunctionInterface[]>();

  dataSource = computed(
    () =>
      new AiToolsTableDataSource(this.aiAssistantService, this.assistantType(), this.accountGroupId$, this.partnerId$),
  );
  tableDataSource = computed(() => new GalaxyDataSource<FunctionInterface, unknown, unknown>(this.dataSource()));

  columns: GalaxyColumnDef[] = [
    {
      id: 'icon',
      title: '',
    },
    {
      id: 'id',
      title: 'Name',
    },
    {
      id: 'description',
      title: 'Description',
    },
  ];

  selectionChanged(selected: Row[]) {
    this.selectedFunctions.emit(selected);
  }

  isRowDisabled(row: FunctionInterface): boolean {
    const id = row?.id ?? '';
    const excluded = this.excludedFunctionIds();
    return !!id && excluded.includes(id);
  }
}
